import { CloseOutlined } from "@ant-design/icons";
import { CardProps } from "antd";
import Text from "../text";
import Card from "../card";

interface Props extends CardProps {
  closable?: any;
  close?: () => void;
}

const Body = ({
  styles,
  closable = true,
  close = () => {},
  ...props
}: Props) => {
  return (
    <Card
      styles={{
        ...styles,
        body: {
          maxHeight: "85vh",
          overflow: "scroll",
          ...(styles?.body ?? {}),
        },
      }}
      extra={
        !!closable && (
          <Text
            level={4}
            onClick={close}
            color="secondary"
            className="cursor-pointer"
            children={<CloseOutlined size={50} />}
          />
        )
      }
      {...props}
    />
  );
};

export default Body;
